// src/pages/VerifyEmail.jsx
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../services/api';

export default function VerifyEmail() {
  const [p] = useSearchParams();      // ?email &codigo
  const go  = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        await api.get('/clientes/verify', { params:{
          email : p.get('email'),
          code  : p.get('codigo'),
        }});
        go('/verificado?ok=1');
      } catch {
        go('/verificado?ok=0');
      }
    })();
  }, []);

  return null;        // un spinner opcional
}
